import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = ["disabled"]

import { computed } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigNewButton',
  setup(__props) {

const backend = useBackendStore();

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.userLoggedIn) {
    return "Log in to create configurations";
  }
  if (
    backend.configList.filter(
      (c) =>
        c.owner == backend.currentConfig?.owner &&
        c.name == backend.currentConfig?.name
    ).length > 0
  ) {
    return "Configuration with this name already exists";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Save as new configuration";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([tooltip.value != null ? 'tooltip' : '']),
    "data-tip": tooltip.value
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(backend).createNewConfig && _unref(backend).createNewConfig(...args))),
      class: "btn btn-accent w-24",
      disabled: _unref(backend).currentConfig == null || error.value != null
    }, " New ", 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})